import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchCollectionsApi,
  addCollectionApi,
  updateCollectionApi,
  deleteCollectionApi,
} from "../services/CollectionService";

// Fetch collections and related data
export const fetchCollections = createAsyncThunk(
  "collections/fetchCollections",
  async (filters = {}) => {
    const response = await fetchCollectionsApi(filters);
    return response;
  }
);

// Add new collection
export const addCollection = createAsyncThunk(
  "collections/addCollection",
  async (collectionData) => {
    const response = await addCollectionApi(collectionData);
    if (response?.head?.code === 200) {
      return response.head.msg;
    } else {
      throw new Error(response?.head?.msg || "An unexpected error occurred while adding the collection.");
    }
  }
);

// Update collection
export const updateCollection = createAsyncThunk(
  "collections/updateCollection",
  async (collectionData) => {
    const response = await updateCollectionApi(collectionData);
    if (response?.head?.code === 200) {
      return response.head.msg;
    } else {
      throw new Error(response?.head?.msg || "An unexpected error occurred while updating the collection.");
    }
  }
);

// Delete collection
export const deleteCollection = createAsyncThunk(
  "collections/deleteCollection",
  async ({ collectionId, currentUserId }) => {
    const response = await deleteCollectionApi(collectionId, currentUserId);
    if (response?.head?.code === 200) {
      return response.head.msg;
    } else {
      throw new Error(response?.head?.msg || "An unexpected error occurred while deleting the collection.");
    }
  }
);

const collectionSlice = createSlice({
  name: "collections",
  initialState: {
    collections: [],
    customers: [],
    areas: [],
    plans: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCollections.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCollections.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.collections = action.payload.collection || [];
        state.customers = action.payload.customer || [];
        state.areas = action.payload.area || [];
        state.plans = action.payload.plan || [];
      })
      .addCase(fetchCollections.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(addCollection.pending, (state) => {
        state.status = "loading";
      })
      .addCase(addCollection.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addCollection.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(updateCollection.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateCollection.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateCollection.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(deleteCollection.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteCollection.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(deleteCollection.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default collectionSlice.reducer;
